// nuolino-admin/src/auth/useAuth.ts
// Hook público consumido por telas. Separado de AuthProvider para
// manter fast-refresh limpo.

import { useContext } from 'react';
import { AuthContext } from './AuthContext';
import type { AuthContextValue } from './AuthProvider';

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within <AuthProvider>');
  return ctx;
}
